import { observer } from 'mobx-react-lite';
import { X, BookOpen } from '@phosphor-icons/react';
import { useResolve } from '@/infrastructure/useResolve';
import { TOKEN_II18n } from '@/services/i18n/I18n';
import { TOKEN_PlayerStore } from './PlayerStore';
import { TOKEN_UploadStore } from './UploadStore';

export const ChapterListView = observer(function ChapterListView() {
  const store = useResolve(TOKEN_PlayerStore);
  const upload = useResolve(TOKEN_UploadStore);
  const i18n = useResolve(TOKEN_II18n);
  if (!store.isChapterListOpen) return null;

  return (
    <div className="fixed inset-0 z-20 flex" role="dialog" aria-label={i18n.t('chapters.title')}>
      <div className="flex-1 bg-ink/30" onClick={store.closeChapterList} />
      <aside className="flex w-80 max-w-[85vw] flex-col border-l border-line bg-surface">
        <div className="flex items-center justify-between border-b border-line px-5 py-4">
          <h3 className="font-serif text-base font-medium text-ink">{i18n.t('chapters.title')}</h3>
          <button
            type="button"
            onClick={store.closeChapterList}
            className="flex h-8 w-8 items-center justify-center rounded-full text-muted hover:bg-line/60 hover:text-ink"
            aria-label={i18n.t('common.close')}
          >
            <X size={18} />
          </button>
        </div>

        <ul className="min-h-0 flex-1 overflow-y-auto p-2">
          {store.chapters.map((chapter, index) => {
            const current = index === store.position.chapter;
            return (
              <li key={index}>
                <button
                  type="button"
                  onClick={() => store.goToChapter(index)}
                  className={`flex w-full items-baseline gap-3 rounded-lg px-3 py-2.5 text-left text-sm transition-colors ${
                    current ? 'bg-accent/12 text-accent-strong' : 'text-ink hover:bg-line/50'
                  }`}
                >
                  <span className="shrink-0 font-serif tabular-nums text-muted">{index + 1}</span>
                  <span className="truncate">{chapter.label}</span>
                </button>
              </li>
            );
          })}
        </ul>

        <div className="border-t border-line p-3">
          <button
            type="button"
            onClick={() => void upload.clearBook()}
            className="flex w-full items-center justify-center gap-2 rounded-full border border-line px-3 py-2.5 text-sm text-muted transition-colors hover:border-accent/50 hover:text-ink"
          >
            <BookOpen size={16} /> {i18n.t('chapters.openOther')}
          </button>
        </div>
      </aside>
    </div>
  );
});
